import { render, staticRenderFns } from "./assign.vue?vue&type=template&id=6eb5cd4b&scoped=true&"
import script from "./assign.vue?vue&type=script&lang=js&"
export * from "./assign.vue?vue&type=script&lang=js&"
import style0 from "./assign.vue?vue&type=style&index=0&id=6eb5cd4b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb5cd4b",
  null
  
)

export default component.exports